import { useState } from 'react';
import { Route, Routes, Navigate } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from 'react-query';
import { ThemeProvider } from 'styled-components';
import {
  Layout,
  AppNavigator,
  Auth,
  ContentManager,
  Modal,
} from './components';
import { GlobalStyle } from './globalStyle';
import { theme } from './theme';
import { Dashboard, Listings, Notifications, RegisterToSell, Contract } from './pages';
import { ModalContextProvider, ModelContextProps } from './state/modal';

const queryClient = new QueryClient();

const App = () => {
  const [modalProps, setModalProps] = useState<ModelContextProps>({});

  const onModalClose = () => {
    modalProps.onClose?.();
    setModalProps({ ...modalProps, isOpen: false });
  };

  return (
    <QueryClientProvider client={queryClient}>
      <ThemeProvider theme={theme}>
        <GlobalStyle />
        <ContentManager>
          <Layout>
            <Auth>
              <ModalContextProvider value={{ modalProps, setModalProps }}>
                <AppNavigator />
                <Routes>
                  <Route
                    path="/"
                    element={<Navigate to="listings" replace />}
                  />
                  <Route path="dashboard" element={<Dashboard />} />
                  <Route path="contract" element={<Contract />} />
                  <Route
                    path="sell"
                    element={
                      <RegisterToSell title="What do you want to sell?" />
                    }
                  />
                  <Route path="listings/*" element={<Listings />} />
                  <Route
                    path="resource-centre"
                    element={<div>Resource Centre View</div>}
                  />
                  <Route path="reports" element={<div>Reports View</div>} />
                  <Route path="other" element={<div>Other View</div>} />
                  <Route path="sundry" element={<div>Sundry View</div>} />
                  <Route path="notifications" element={<Notifications />} />
                </Routes>
                <Modal {...modalProps} onClose={onModalClose} />
              </ModalContextProvider>
            </Auth>
          </Layout>
        </ContentManager>
      </ThemeProvider>
    </QueryClientProvider>
  );
};

export default App;
